<div class="container">
  <h2>Kursbewerbungen</h2>

  <!-- Filter by Level -->
  <div class="mb-3">
    <label for="levelFilter" class="form-label">Nach Niveau filtern:</label>
    <select id="levelFilter" class="form-select" [(ngModel)]="selectedLevel" (change)="filterByLevel()">
      <option value="">Alle Niveaus</option>
      <option value="A1-A2">A1-A2</option>
      <option value="B1-B2">B1-B2</option>
    </select>
  </div>

  <div class="table-responsive always-scroll">
    <table class="table table-striped align-middle dashboard-table">
      <thead>
        <tr>
          <th>Benutzer</th>
          <th>E-Mail</th>
          <th>Telefon</th>
          <th>Kursniveau</th>
          <th>Status</th>
          <th>Bewerbungsdatum</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let app of applications" class="application-row">
          <td>{{ app.userName }}</td>
          <td>{{ app.userEmail }}</td>
          <td>{{ app.phone }}</td>
          <td>{{ app.level }}</td>
          <td>{{ app.status }}</td>
          <td>{{ app.createdAt?.toDate() | date:'short' }}</td>
        </tr>

        <tr *ngIf="applications.length === 0 && !showSpinner" style="text-align: center;">
          <td colspan="6" class="text-muted">Keine Kursbewerbungen verfügbar</td>
        </tr>

        <tr *ngIf="showSpinner" style="text-align: center;">
          <td colspan="6">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Lädt...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>